var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.921,
    cy: 34.998,
    r: 34.998,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.788 60.52a.766.766 0 0 1 1.357 0l1.686 3.227c.036.07.092.126.162.162l3.228 1.687a.766.766 0 0 1 0 1.357l-3.228 1.685a.383.383 0 0 0-.162.162l-1.686 3.229a.766.766 0 0 1-1.357 0L54.105 68.8a.383.383 0 0 0-.163-.162l-3.23-1.685a.766.766 0 0 1 0-1.357l3.23-1.687a.383.383 0 0 0 .163-.162l1.683-3.227zM16.736.84a.445.445 0 0 1 .79 0l.98 1.878c.021.04.054.073.095.094l1.878.98a.445.445 0 0 1 0 .79l-1.878.98a.223.223 0 0 0-.095.095l-.98 1.878a.445.445 0 0 1-.79 0l-.979-1.878a.223.223 0 0 0-.094-.095l-1.879-.98a.445.445 0 0 1 0-.79l1.88-.98a.223.223 0 0 0 .094-.094L16.736.84z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.835 18.948a.33.33 0 0 1 .584 0l.724 1.387c.016.03.04.054.07.07l1.388.724a.33.33 0 0 1 0 .584l-1.388.724a.165.165 0 0 0-.07.07l-.724 1.388a.33.33 0 0 1-.584 0l-.723-1.388a.165.165 0 0 0-.07-.07l-1.388-.724a.329.329 0 0 1 0-.584l1.388-.724a.164.164 0 0 0 .07-.07l.723-1.387zM3.673 48.5a.48.48 0 0 1 .85 0l1.055 2.02a.24.24 0 0 0 .101.101L7.7 51.677a.48.48 0 0 1 0 .85L5.68 53.58a.24.24 0 0 0-.102.102l-1.055 2.02a.48.48 0 0 1-.85 0l-1.054-2.02a.24.24 0 0 0-.101-.102L.495 52.527a.48.48 0 0 1 0-.85l2.023-1.056a.239.239 0 0 0 .101-.102l1.054-2.02z",
    fill: "#EFEFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.275 20.84a3.375 3.375 0 0 0-4.152 2.336l-2.407 8.527a4.375 4.375 0 0 0 .402 3.341l9.226 16.324a2.375 2.375 0 0 0 3.236.9l13.157-7.437a2.375 2.375 0 0 0 .899-3.236l-9.231-16.332a4.375 4.375 0 0 0-2.638-2.063l-8.492-2.36zm-3.43 2.54a2.625 2.625 0 0 1 3.23-1.817l8.492 2.36a3.625 3.625 0 0 1 2.185 1.709l7.851 13.891-16.043 8.935-7.79-13.783a3.625 3.625 0 0 1-.332-2.768l2.407-8.528zm6.084 25.73L24.997 51a1.625 1.625 0 0 0 2.214.614l13.157-7.435a1.625 1.625 0 0 0 .615-2.215l-1.01-1.788-16.044 8.935zm.157-22.798a2.172 2.172 0 1 1-3.783 2.138 2.172 2.172 0 0 1 3.783-2.138zm5.15 3.366a.25.25 0 0 1 .341.095l3.694 6.535a.25.25 0 1 1-.436.246l-3.693-6.535a.25.25 0 0 1 .095-.34zm-4.012 2.556a.25.25 0 0 0-.435.246l5.052 8.939a.25.25 0 0 0 .435-.246l-5.052-8.939zm-4.353 2.461a.25.25 0 1 0-.435.246l2.26 3.997a.25.25 0 0 0 .434-.246l-2.259-3.997z",
    fill: "#7E7E7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.125 17.41a4.116 4.116 0 0 0-3.859 4.377l.062.944.913-.06-.062-.944a3.201 3.201 0 0 1 3.001-3.404l5.968-.361c1.17-.071 2.32.326 3.198 1.103l9.827 8.705-10.651 11.873.68.61 10.656-11.876.702.622c.822.728.895 1.984.165 2.803L41.23 42.444l.683.61 9.495-10.643a2.896 2.896 0 0 0-.241-4.097l-11.214-9.933a5.336 5.336 0 0 0-3.86-1.332l-5.968.36zm2.775 3.892a1.885 1.885 0 1 1-2.5 2.822 1.885 1.885 0 0 1 2.5-2.822zm5.54 1.223a.305.305 0 1 0-.403.457L42.91 27.3a.305.305 0 1 0 .404-.457l-4.874-4.318zM35.135 25.8a.305.305 0 0 1 .43-.026l6.668 5.907a.305.305 0 1 1-.404.456L35.16 26.23a.305.305 0 0 1-.026-.43z",
    fill: "#7E7E7E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.279,
    cy: 41.38,
    r: 7.935,
    fill: "#fff",
    stroke: "#7E7E7E",
    strokeWidth: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.278,
    cy: 41.377,
    r: 5.59,
    fill: "#31B59F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.526 41.844h-2.783v2.783h-.928v-2.783h-2.782v-.928h2.782v-2.782h.928v2.782h2.783v.928z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.d3388f1876c249954e03e6eb7605be77.svg";
export { ForwardRef as ReactComponent };